import React from "react";

const InertiaFeatures = () => {
  return (
    <>
      <div className="md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div className="col-span-1 mb-6 md:mb-0 row-span-1 lg:h-[270px] bg-[#3b82f6] rounded-3xl">
          <div className="p-6">
            <img
              alt="High Brightness"
              src="https://content.qeeb.in/coltec/products/active-led/listing/high-brightness.webp"
              className="flex h-[110px] items-end justify-end mb-3 ml-auto"
            />
            <h2 className="text-white text-lg font-semibold mb-2">
              High Brightness
            </h2>
            <p className="text-white text-xs font-medium">
              Illuminate any space with exceptional luminance, ensuring vibrant
              visuals and crystal-clear imagery even in the brightest
              conditions.
            </p>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[330px] bg-[#3b82f6] rounded-3xl">
          <div>
            <div className="px-6 pt-6">
              <h2 className="text-white text-lg font-semibold mb-3">
                Wide Viewing Angles
              </h2>
              <p className="text-white text-xs font-medium  ">
                Enjoy consistently clear visuals from any viewpoint delivering
                immersive clarity up to 160°, keeping your content visible and
                engaging from every angle.
              </p>
            </div>
            <div className="flex justify-center">
              <img
                alt="Wide Viewing Angles"
                src="https://content.qeeb.in/coltec/products/active-led/listing/wide-viewing-angles.webp"
                className="h-[190px] object-contain"
              />
            </div>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[330px] bg-white rounded-3xl border-4 border-[#3b82f6]">
          <div className="p-6">
            <img
              alt="Ultra-High Resolution"
              src="https://content.qeeb.in/coltec/products/active-led/listing/ultra-high-resolution.webp"
              className="mb-3 h-[160px] w-full object-cover"
            />
            <h2 className="text-[#4282ff] text-lg font-semibold  mb-3">
              Ultra-High Resolution
            </h2>
            <p className="text-black text-xs font-medium">
              Experience the cutting-edge display technology that brings every
              detail to life with crystal-clear clarity and vibrant,
              breathtaking visuals.
            </p>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[300px] xl:mt-[-55px] bg-white rounded-3xl border-4 border-[#3b82f6]">
          <div className="p-6">
            <img
              alt="Cabinet Aspect Ratio"
              src="https://content.qeeb.in/coltec/products/active-led/listing/cabinet-aspect-ration.webp"
              className="h-[150px] w-full object-cover mb-3"
            />
            <h2 className="text-[#4282ff] text-lg font-semibold mb-1">
              16:9 Cabinet Aspect Ratio
            </h2>
            <div className="text-black text-xs font-medium  ">
              Enjoy stunning visuals in a natural, cinematic format ensuring
              perfect viewing experiences for every environment.
            </div>
          </div>
        </div>
        <div className="col-span-2 row-span-1 bg-[#3b82f6] rounded-3xl">
          <div className="p-6">
            <div className="flex justify-start lg:space-x-5 md:flex-nowrap flex-wrap">
              <img
                alt="Bezel-Free Design"
                src="https://content.qeeb.in/coltec/products/active-led/listing/bezel-free-design.webp"
                className="h-[160px]"
              />
              <div className="mt-3 lg:mt-0">
                <h2 className="text-white text-lg font-semibold ">
                  Bezel-Free Design
                </h2>
                <p className="text-white text-xs font-medium  ">
                  Enjoy seamless visuals without distracting borders. The sleek,
                  bezel-free display delivers uninterrupted imagery and enhances
                  engagement, creating a sophisticated look perfect for modern
                  conference rooms and retail environments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InertiaFeatures;
